import { enGB as en, arSA as ar } from 'date-fns/locale'
import { formatInTimeZone, format } from 'date-fns-tz'
const defaultTimeZone = 'Asia/Qatar'

export function baseFormatDate (value, locale, mask, tz) {
  let formatString = locale === 'ar' ? 'd MMMM yyyy' : 'd MMM yyyy'
  if (mask) {
    formatString = mask
  }
  const formatLocale = locale === 'ar' ? ar : en
  const marker = locale === 'ar' ? '\u200f' : ''
  const getFormat = () =>
    tz ? formatInTimeZone(value, tz, `${marker}${formatString}`, { locale: formatLocale }) : format(value, `${marker}${formatString}`, { locale: formatLocale })
  return value ? getFormat() : ''
}

export function formatDate (value, locale, mask, tz = defaultTimeZone) {
  return baseFormatDate(value, locale, mask, tz)
}

export function formatDateWithoutTz (value, locale, mask) {
  return baseFormatDate(value, locale, mask)
}
